import _extends from "@swc/helpers/src/_extends.mjs";
import React from 'react';
import { useEnabledFlagList } from './hooks/useEnabledFlagList';
export default function withFeatureFlags(Component) {
    const Decorated = (props)=>{
        const flags = useEnabledFlagList();
        return /*#__PURE__*/ React.createElement(Component, _extends({
            flags: flags
        }, props));
    };
    Decorated.displayName = `withFeatureFlags(${Component.displayName || 'Component'})`;
    return Decorated;
}
